import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { AccountApiService } from '../api';
import { getAccountMock, getSessionsMock } from './index';
import { GetAccountRes, GetSessionsRes, SaveAccountRes } from '../models';

@Injectable()
export class AccountMockApiService extends AccountApiService {
  override getAccount(): Observable<GetAccountRes> {
    const account = getAccountMock();

    return of(account).pipe(delay(500));
  }

  override saveAccount(): Observable<SaveAccountRes> {
    return of(null).pipe(delay(500));
  }

  override getSessions(): Observable<GetSessionsRes> {
    const sessions = getSessionsMock();

    return of({ itemsCount: sessions.length, sessions }).pipe(delay(500));
  }
}
